import {
  getItemFromLocalStorage,
  removeItemFromLocalStorage,
  setItemInLocalStorage,
} from '@/utility/localstorage';

const SSO_AUTH_ORIGIN_URL = 'social_auth_origin_url';

export const getSSOAuthOriginURL = () => {
  const ssoAuthOriginURL = getItemFromLocalStorage(SSO_AUTH_ORIGIN_URL);
  return ssoAuthOriginURL?.replace(/(https?:\/\/[-\w.:]+)\//, '/');
};

export const rememberSSOAuthOriginURL = () => {
  const restoreURL = window.location.pathname + window.location.search;

  // Never remember to restore the URL of the login page. This exception is important
  // so if the user tried to login with SSO and failed, it will get redirected to the login page
  // and then the restore URL will be set to the login page now if he tries again.
  if (restoreURL.startsWith('/users/new') || restoreURL.startsWith('/sessions/new')) return;

  setItemInLocalStorage(SSO_AUTH_ORIGIN_URL, restoreURL);
};

export const clearSSOAuthOriginURL = () => {
  removeItemFromLocalStorage(SSO_AUTH_ORIGIN_URL);
};
